module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e31"
    }
  }, [_c('b', [_vm._v("OTHERS BOOKS BY JONI EARECKSON TADA")])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d12e34"
    }
  }, [_c('i', [_vm._v("How to Be a Christian in a Brave New World ")]), _c('br'), _vm._v("(with Nigel M. de S. Cameron) "), _c('br'), _c('i', [_vm._v("The God I Love ")]), _c('br'), _c('i', [_vm._v("Diamonds in the Dust ")]), _c('br'), _c('i', [_vm._v("More Precious Than Silver ")]), _c('br'), _c('i', [_vm._v("Heaven ")]), _c('br'), _c('i', [_vm._v("When God Weeps ")]), _vm._v("(with Steve Estes) "), _c('br'), _c('i', [_vm._v("Joni ")]), _vm._v("(with Joe Musser) "), _c('br'), _c('i', [_vm._v("A Step Further ")]), _vm._v("(with Steve Estes) "), _c('br'), _c('i', [_vm._v("All God’s Children ")]), _vm._v("(with Gene Newman) "), _c('br'), _c('i', [_vm._v("Barrier-Free Friendships ")]), _vm._v("(with Steve Jensen) "), _c('br'), _c('i', [_vm._v("The Life and Death Dilemma")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed26d56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tada_9780310297864_epub_c2_r1.vue
// module id = 60
// module chunks = 0